<template>
  <div className="d-flex justify-content-between">
    <el-form :inline="true" size="small">
      <el-form-item>
        <el-input
          v-model="formData.coinType"
          placeholder="币种"
          class="width-100"
          clearable
          @clear="searchBtnClick"
          @keypress.enter="searchBtnClick"
        ></el-input>
      </el-form-item>

      <el-form-item>
        <el-select
          v-model="formData.status"
          class="width-100"
          clearable
          @clear="searchBtnClick"
          @change="searchBtnClick"
        >
          <el-option label="产品状态" value=""></el-option>
          <el-option label="预热中" :value="0"></el-option>
          <el-option label="进行中" :value="1"></el-option>
          <el-option label="已结束" :value="4"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item>
        <el-select
          v-model="formData.isDisplay"
          class="width-150"
          clearable
          @clear="searchBtnClick"
          @change="searchBtnClick"
        >
          <el-option label="发行状态" value=""></el-option>
          <el-option label="开启中" :value="1"></el-option>
          <el-option label="隐藏(用户不可见)" :value="0"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item>
        <el-date-picker
          v-model="formData.period"
          type="daterange"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :shortcuts="shortcuts"
          class="width-250"
          @change="searchBtnClick"
        ></el-date-picker>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="searchBtnClick">查询</el-button>
        <el-button type="warning" @click="resetBtnClick">重置</el-button>
        <el-button type="success" @click="addBtnClick">添加</el-button>
      </el-form-item>
    </el-form>

    <el-form :inline="true" size="small">
      <el-form-item label="发放利息">
        <el-popconfirm title="确定更改？" @confirm="switchInterest">
          <template #reference>
            <el-switch :value="isOpenInterest"></el-switch>
          </template>
        </el-popconfirm>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

import { dateShortcuts } from '@/utils/encrypt.js'
// import { fetchStakingSwitchConf, fetchStakingSwitchSet } from '@/api/staking';

export default {
  data() {
    return {
      formData: {
        isDisplay: '',
        status: '',
        coinType: '',
        period: '',
      },
      shortcuts: [],
      isOpenInterest: false,
    }
  },
  computed: {
    // ...mapState('bill', ['billList', 'pagination', 'totalCount']),
  },
  methods: {
    ...{ dateShortcuts },

    ...mapActions('financial', ['setStakingSwitchConf', 'setStakingSwitchSet']),
    switchInterest() {
      this.setStakingSwitchSet({
        isOpen: !this.isOpenInterest,
      }).then(() => {
        this.isOpenInterest = !this.isOpenInterest
      })
    },
    searchBtnClick() {
      this.$emit('search', this.formData)
    },
    resetBtnClick() {
      Object.assign(this.formData, {
        isDisplay: '',
        status: '',
        coinType: '',
        period: '',
      })
      this.searchBtnClick()
    },
    addBtnClick() {
      this.$emit('add')
    },
  },

  mounted() {
    this.shortcuts = this.dateShortcuts()
    this.setStakingSwitchConf().then((res) => {
      this.isOpenInterest = res.data
    })
  },
}
</script>

<style scoped></style>
